import { soyshareApi } from '../../../../../services/api'
import { savingMessagesNotification } from '../helpers/messages'

const api = soyshareApi.injectEndpoints({
  endpoints: (build) => ({
    getFieldRelationships: build.query({
      query: ({ fieldId, ...params }) => ({ url: `/form-fields/relationships/${fieldId}`, params }),
      providesTags: ['form-field-relationships']
    }),

    createFormFieldRelationship: build.mutation({
      query: ({ payload }) => ({
        url: '/form-fields/relationships',
        method: 'POST',
        body: payload
      }),
      onQueryStarted: async ({ payload }, { dispatch, queryFulfilled }) => {
        savingMessagesNotification.saving()
        const { data } = await queryFulfilled
        dispatch(
          api.util.updateQueryData('getFieldRelationships', { fieldId: payload.mainFieldId }, (draft) => {
            draft.main[payload.relatedFieldId] = data.id
            return draft
          })
        )
        savingMessagesNotification.success()
      }
    }),

    removeFormFieldRelationship: build.mutation({
      query: ({ payload }) => ({
        url: '/form-fields/relationships',
        method: 'DELETE',
        body: payload
      }),
      onQueryStarted: async (_, { queryFulfilled }) => {
        savingMessagesNotification.saving()
        await queryFulfilled
        savingMessagesNotification.success()
      },
      invalidatesTags: ['form-field-relationships']
    })
  })
})

export const {
  useGetFieldRelationshipsQuery,
  useCreateFormFieldRelationshipMutation,
  useRemoveFormFieldRelationshipMutation
} = api
